import { MajorServiceClassification } from '../major-service-classification';
import { MinorServiceClassification } from '../minor-service-classification';
import { TestedParty } from '../tested-party';

export class MinorClassificationsModalPayload {
  testedParty: TestedParty;
  testedPartyMajorClassification: MajorServiceClassification;
  minorServiceClassifications: MinorServiceClassification[];
}
